// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uLzoI","col":"styles_col__3S8mh"};